import React, { Component,ReactElement,useState } from "react";
import Link from "../../components/html/link";

import PageLayout from '../../components/layout/PageLayout'
import {ThemeProps} from "../../components/styles/themeprops";
import { Fade } from "react-awesome-reveal";

import "./notfound.css";
import NotfoundImg from "./NotfoundImg";
import { patiApi } from '../../components/misc/PatiApi'
import {handleLogError} from "../../components/misc/Helpers";
import { useTranslation } from "react-i18next";

type ContactFormData = {
  [key: string]: any; 
}
type LoginRequestState = { running?: boolean,isError?:boolean, error?: string,successful?:boolean,message?:string,};
type Props = {theme: ThemeProps,}

export default function NotFound({ theme }: Props) {
		const { t, i18n } = useTranslation();
    return (
			<div className="notfound">
				<div className="basic-projects">
					<Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
						<div className="projects-heading-div">
							<div className="imprint-heading-img-div">
								<NotfoundImg theme={theme} />
							</div>
							<div className="projects-heading-text-div">
								<h1 className="projects-heading-text">{t("notfound")}</h1>
								<p className="projects-header-detail-text subTitle">
									{t("notfound.description")}
								</p>
								<Link text="Go Back to homepage" href="/"
                  className="portfolio-repo-btn btnbackhomepage"/>
							</div>
						</div>
					</Fade>
				</div>
			</div>
			
      
    )
}